import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Development">
                            <h2>Custom Blockchain App Development Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>The prospect of improving your organizational performance and operational processes, cutting expenses, and eliminating third-party interference and technical hindrances are challenging but achievable.</p>
                       <p>We offer a wide array of solutions ranging from Blockchain and cryptocurrency development, including exchanges, trading apps, crypto wallets, smart contracts, and banking and finance through Blockchain support. Our purpose is to help our clients secure a formidable future when the future unfolds, and new opportunity arises for customer engagement and revenue streams.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;